export class FeedInfo {
  public name: string;
  public description: string;
  public updated: Date;
  public help: string;
  public channels: FeedChannel[];

  constructor(data: any) {
    this.name = data.name;
    this.description = data.description;
    this.updated = new Date(data.updated);
    this.help = data.help;

    this.channels = [];
    for (const channel of data.channels) {
      this.channels.push(new FeedChannel(channel));
    }
  }
}

export class FeedChannel {
  public name: string;
  public description: string;
  public machines: string[];
  public releases: FeedChannelRelease[];

  constructor(data: any) {
    this.name = data.name;
    this.description = data.description;
    this.machines = data.machines;

    this.releases = [];
    for (const release of data.releases) {
      this.releases.push(new FeedChannelRelease(release));
    }
  }
}

export class FeedChannelRelease {
  public machines: string[];
  public version: string;
  public path: string;

  constructor(data: any) {
    this.machines = data.machines;
    this.version = data.version;
    this.path = data.path;
  }
}
